import { DetailsHeaderItem, DetailsPicture } from "../Details";
import PictureGallery from "../Pictures/PictureGallery";
import { picturesShape } from "../../shapes";

type Props = {
  productPictureUrl?: string;
  pictures?: picturesShape;
  serialNumber: string;
  productName?: string;
  manufacturerName: string;
};

export default function AssetDetailsBasicInfo({
  productPictureUrl,
  pictures,
  serialNumber,
  productName,
  manufacturerName,
}: Props) {
  return (
    <>
      <DetailsPicture>
        <PictureGallery
          // @ts-expect-error TS(2322) FIXME: Type '{ additionalPictureUrls: string[] | null; pi... Remove this comment to see the full error message
          additionalPictureUrls={productPictureUrl ? [productPictureUrl] : null}
          pictures={pictures}
          placeholder="icon-eh-device"
        />
      </DetailsPicture>
      <DetailsHeaderItem
        id="asset-serialnumber"
        translationKey="label.serial_number"
        value={serialNumber}
        breakValue
      />
      <DetailsHeaderItem
        id="asset-product-name"
        translationKey="label.product_name"
        value={productName}
      />
      <DetailsHeaderItem
        id="asset-manufacturer"
        translationKey="label.manufacturer"
        value={manufacturerName}
      />
    </>
  );
}
